import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Library } from "./pages/Library.js";
import { Lecture } from "./pages/Lecture.js";
import { ClipEditor } from "./pages/ClipEditor.js";
import { Posting } from "./pages/Posting.js";
import { Settings } from "./pages/Settings.js";
import { ErrorBoundary } from "./components/ErrorBoundary.js";
import { TopBar, TabBar } from "./components/TopBar.js";
import { Queue } from "./pages/Queue.js";
import { Costs } from "./pages/Costs.js";

/** The shell: one bar on top of every page except the clip editor, which has its own. */
export const App: React.FC = () => {
  const { pathname } = useLocation();
  const inEditor = pathname.startsWith("/clips/");
  return (
    <div className="shell">
      {inEditor ? null : <TopBar />}
      <div className="view">
        <Routes>
          <Route path="/" element={<ErrorBoundary name="library"><Library /></ErrorBoundary>} />
          <Route path="/lectures/:v" element={<ErrorBoundary name="lecture page"><Lecture /></ErrorBoundary>} />
          <Route path="/clips/:v/:c" element={<ErrorBoundary name="clip editor"><ClipEditor /></ErrorBoundary>} />
          <Route path="/posting" element={<ErrorBoundary name="posting board"><Posting /></ErrorBoundary>} />
          <Route path="/settings" element={<ErrorBoundary name="settings"><Settings /></ErrorBoundary>} />
          <Route path="/costs" element={<ErrorBoundary name="spending"><Costs /></ErrorBoundary>} />
          <Route path="/queue" element={<ErrorBoundary name="queue"><Queue /></ErrorBoundary>} />
        </Routes>
      </div>
      {inEditor ? null : <TabBar />}
    </div>
  );
};
